import React, { Component } from 'react';
import { Button, FormGroup, ControlLabel, FormControl, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import firebase from 'firebase';
import PlacesAutocomplete from 'react-places-autocomplete';
import {
    geocodeByAddress,
    geocodeByPlaceId,
    getLatLng,
} from 'react-places-autocomplete';

import '../../src/main.css';
import { addItem } from '../actions';
import withAuthorization from './withAuthorization';

const AddPage = (props, { authUser }) =>
    <div>
        <AddContainer />
    </div>

AddPage.contextTypes = {
    authUser: PropTypes.object,
};

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(AddPage);

export class Add extends Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.uploadFile = this.uploadFile.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setImageData = this.setImageData.bind(this);
        this.state = {
            id: '1',
            name: '',
            lat: '',
            lng: '',
            date: '',
            description: '',
            date: '',
            imgUrl: require('../images/p2.jpg'),
            uploadingFile: false,
            uploadComplete: false,
            address: ''
        };
    }

    getValidationState() {
        const length = this.state.value.length;
        if (length > 10) return 'success';
        else if (length > 5) return 'warning';
        else if (length > 0) return 'error';
        return null;
    }

    handleChange(e) {
        const target = e.target;
        const name = target.name;
        this.setState({ [name]: target.value });
    }

    setImageData(imageData) {
        this.setState({
            uploadComplete: true,
            uploadingFile: false
            //imgUrl: imageData
        })
    }

    uploadFile(e) {
        var self = this;
        let file = e.target.files[0];
        if (file) {
            let reader = new FileReader();
            this.setState({
                uploadingFile: true
            })
            reader.addEventListener("load", function () {
                self.setState({
                    imgUrl: reader.result,
                    uploadComplete: true,
                    uploadingFile: true
                })
            }, false);

            if (file) {
                reader.readAsDataURL(file);
            }
            // axios.post('/files', data)...
        }
    }

    handleSubmit() {
        let newItem = this.toNewRecord(this.state);
        this.props.addItem({ newItem });
        let conn = firebase.database().ref('/items');
        conn.push(newItem);
        this.setState({
            name: '',
            lat: '',
            lng: '',
            description: '',
            date: '',
            address: '',
            imgUrl: require('../images/p2.jpg')
        });
    }

    toNewRecord(obj) {
        var newItem = {
            name: obj.name, imgUrl: obj.imgUrl,
            description: obj.description, position: { lat: obj.lat, lng: obj.lng },
            date: obj.date, address: obj.address
        };
        return newItem;
    }

    handleAddressChange = address => {
        this.setState({ address });
    };

    handleSelect = address => {
        const self = this;
        geocodeByAddress(address)
            .then(results => {
                self.setState({ 
                    address: results[0].formatted_address,
                });

                return results;
            })
            .then(results => getLatLng(results[0]))
            .then(latLng => {
                self.setState({ 
                    lat: latLng.lat,
                    lng: latLng.lng
                });
            })
            .catch(error => console.error('Error', error));
    };

    render() {
        return (
            <div className="form-div" style={{ width: '50%', padding: 50 }}> <h3>New Record </h3>
                <div className="well">
                    <form>
                        <FormGroup controlId="formControlsName">
                            <Row className="show-grid">
                                <Col md={6}>
                                    <FormControl
                                        type="text"
                                        name="name"
                                        value={this.state.name}
                                        placeholder="Enter Name"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </Col>
                                <Col md={6}>
                                    <FormControl
                                        type="text"
                                        name="date"
                                        value={this.state.date}
                                        placeholder="Enter Date"
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>

                        <FormGroup controlId="formControlsName">
                            <Row className="show-grid">
                                <Col md={6}>
                                    <PlacesAutocomplete
                                        value={this.state.address}
                                        onChange={this.handleAddressChange}
                                        onSelect={this.handleSelect}
                                    >
                                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                            <div>
                                                {/* <input
                                                    {...getInputProps({
                                                        placeholder: 'Search Places ...',
                                                        className: 'location-search-input',
                                                    })}
                                                /> */}
                                                    <FormControl
                                                        {...getInputProps({
                                                            placeholder: 'Search City ...',
                                                            className: 'location-search-input',
                                                        })}
                                                    />
                                                <div className="autocomplete-dropdown-container">
                                                    {loading && <div>Loading...</div>}
                                                    {suggestions.map(suggestion => {
                                                        const className = suggestion.active
                                                            ? 'suggestion-item--active'
                                                            : 'suggestion-item';
                                                        // inline style for demonstration purpose
                                                        const style = suggestion.active
                                                            ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                            : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                                        return (
                                                            <div
                                                                {...getSuggestionItemProps(suggestion, {
                                                                    className,
                                                                    style,
                                                                })}
                                                            >
                                                                <span style={{ padding: 10 }}>{suggestion.description}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </PlacesAutocomplete>
                                </Col>
                            </Row>
                        </FormGroup>
                        <FormGroup>
                            <input type="file"
                                name="myFile"
                                onChange={this.uploadFile}
                            />
                        </FormGroup>
                        <FormGroup controlId="formControlsDes">
                            <FormControl componentClass="textarea"
                                placeholder="Description"
                                name="description"
                                value={this.state.description}
                                onChange={(e) => this.handleChange(e)}
                            />
                        </FormGroup>
                        {this.state.uploadComplete ?
                            <Button bsStyle="primary" onClick={this.handleSubmit}>Submit</Button>
                            : <Button bsStyle="primary" onClick={this.handleSubmit} disabled>Submit</Button>
                        }

                    </form>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addItem: (item) => dispatch(addItem(item))
    }
};

const AddContainer = connect(null, mapDispatchToProps)(Add);



// WEBPACK FOOTER //
// ./src/components/Add.js